
import React from 'react'
import { I18n } from '@front/volcanion'

import { IconButton, Button, Backdrop, Box, Typography, Fade, Icon } from '@mui/material'

const WaitPage = props => {
  const {
    isWaiting,
    handleClickHistory,
    handleClickCreateOrder,
    handleClickReturnHome
  } = props
  return (<Box >
    <Box sx={{ position: 'absolute', top: 4, left: 16, zIndex: 700, display: 'flex', alignItems: 'center', height: 36 }}>
      <IconButton
        color='primary'
        onClick={handleClickReturnHome}
      >
        <Icon fontSize='large' sx={{ color: isWaiting ? 'white' : undefined, "&:hover": { color: 'white' } }}>arrow_back</Icon>
      </IconButton>
    </Box>
    <Backdrop
      open={isWaiting}
      sx={{ zIndex: 650, backgroundColor: '#000000B2', color: '#fff' }}
    >
      <Fade in timeout={2000}>
        <Box sx={{ alignItems: 'center', justifyContent: 'center', h: 1, w: 1 }}>
          <Box sx={{ mb: 2, mt: 2 }}>
            <Typography sx={{ fontSize: 'h1.fontSize', color: 'white', fontWeight: 200, letterSpacing: 3 }}>
              {I18n.t('order.wait_call')}
            </Typography>
          </Box>
          <Box sx={{ mb: 5, display: 'flex', justifyContent: 'center' }}>
            <Button
              variant='contained'
              startIcon={<Icon>add</Icon>}
              sx={{ bgcolor: 'white', color: 'primary.main', "&:hover": { color: "white", bgcolor: 'primary.main' } }}
              size='large'
              onClick={handleClickCreateOrder}
            >
              <Typography sx={{ fontWeight: 400, fontSize: 28, letterSpacing: 2 }}>
                {I18n.t('order.create')}
              </Typography>
            </Button>
          </Box>

          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <Button
              variant='contained'
              startIcon={<Icon>timeline</Icon>}
              sx={{ bgcolor: 'white', color: 'primary.main', "&:hover": { color: "white", bgcolor: 'primary.main' } }}
              size='large'
              onClick={handleClickHistory}
            >
              <Typography sx={{ fontWeight: 500, fontSize: 18 }}>
                {I18n.t('history.operator')}
              </Typography>
            </Button>
          </Box>
        </Box>
      </Fade>
    </Backdrop>
  </Box >)
}

export default React.memo(WaitPage)
